import { createAction } from 'redux-actions';

export const productionUnitListChangePage = createAction(
  'PRODUCTION_UNIT_LIST_CHANGE_PAGE'
);

export const resetListCertificatesAction = createAction(
  'PRODUCTION_UNIT_CERTIFICATES_LIST_RESET'
);
